import { useContext } from 'react';

import { SwitchUserRoleContext } from './SwitchUserRoleProvider';

export function useSwitchUserRole() {
  const value = useContext(SwitchUserRoleContext);
  return value;
}
